/// <amd-module name="VSSUI/Registration/LayerComponentRegistration" />
import { VssComponent } from "VSS/Platform/Layout";
import { CornerDialog, Dialog, CustomDialog } from "../Dialog";
import { CustomPanel } from "../Panel";
import { Toast } from "../Toast";

VssComponent.register("cornerDialog", CornerDialog);
VssComponent.register("customPanel", CustomPanel);
VssComponent.register("dialog", Dialog);
VssComponent.register("customDialog", CustomDialog);
VssComponent.register("toast", Toast);
